import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';
import { link, SanityLink } from './link';

export const SanityComparisonCards = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('comparisonCards'),
  _key: z.string(),
  title: z.string(),
  eyebrow: z.string().optional().nullable(),
  cards: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      badge: z.string().optional().nullable(),
      description: z.string(),
      features: z.array(
        z.object({
          _key: z.string(),
          featureText: SanityBasicText,
        }),
      ),
      cta: SanityLink.nullable(),
    }),
  ),
});
export type SanityComparisonCards = z.infer<typeof SanityComparisonCards>;

export const comparisonCards = groq`{
  _type,
  _key,
  title,
  eyebrow,
  cards[] {
    _key,
    title,
    badge,
    description,
    features[] {
      _key,
      featureText[] ${basicText},
    },
    cta[0] ${link},
  },
}`;
